import { ref, shallowRef, watch } from 'vue';
import { toValue } from '../assets/js/vue/utlis/toValue';

/**
 * Для создания клона реактивной переменной
 * @param {import('vue').Ref<*>} original - клонируемое значение. **для объектов клонируется ссылка**
 * @param {(val: any) => void} cb - коллбэк
 * @param {boolean} options.deep - тип реактивности
 */
export const useSyncValue = (original, cb, options = {}) => {
    const deep = options?.deep ?? false;
    const value = deep ? ref(toValue(original)) : shallowRef(toValue(original));
    watch(original, (val) => value.value = val);
    watch(value, (val) => {
        if (val === toValue(original)) return;
        if (typeof cb === 'function') cb(val);
    });

    return {
        value,
    };
};
